import { render, staticRenderFns } from "./c_tag_list.vue?vue&type=template&id=1aaebd98&scoped=true"
import script from "./c_tag_list.vue?vue&type=script&lang=js"
export * from "./c_tag_list.vue?vue&type=script&lang=js"
import style0 from "./c_tag_list.vue?vue&type=style&index=0&id=1aaebd98&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaebd98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aaebd98')) {
      api.createRecord('1aaebd98', component.options)
    } else {
      api.reload('1aaebd98', component.options)
    }
    module.hot.accept("./c_tag_list.vue?vue&type=template&id=1aaebd98&scoped=true", function () {
      api.rerender('1aaebd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_tag_list.vue"
export default component.exports